import { useState } from "react";

export const useHover = (
    disallowTouch = false,
): [
    boolean,
    Readonly<{
        onMouseEnter: () => void;
        onMouseLeave: () => void;
        onTouchStart: () => void;
        onTouchEnd: () => void;
    }>,
] => {
    const [isHovered, setHovered] = useState(false);

    return [
        isHovered,
        {
            onMouseEnter(): void {
                setHovered(true);
            },
            onMouseLeave(): void {
                setHovered(false);
            },

            onTouchStart(): void {
                setHovered(!disallowTouch);
            },
            onTouchEnd(): void {
                setHovered(false);
            },
        },
    ];
};
